import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import { AppRouter } from './routes/AppRouter';

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <AppRouter />
  </StrictMode>,
);
